/* jade-v2-bar.js · the sticky bar's size picker (package C). Ported from v5's s-bar.js.
   The product on the bar is a button that opens a small panel of the sizes. The rows are built here from the tier store
   (SSD.TIERS, which reads the REAL #packs radios), so no number lives in this file, and choosing a row calls SSD.tier.set,
   which checks the matching hero radio: pdp-atc.js then repaints #sbprice and #atcprice, and the bar's own label follows.
   There is no second form and no second add: the bar's Add to cart is pdp-atc.js's [data-sticky-add] handler.
   A disclosure (aria-expanded), not a modal: the bar stays usable. Pointer taps close it after a beat; arrow keys only
   browse (Enter confirms). It also closes on Escape, an outside tap, 90 px of scroll, a resize, or when the bar hides.
   Visibility of the bar itself is pdp-atc.js's (.show / aria-hidden). Transform and opacity only. */
(function (w, d) {
  'use strict';
  if (w.__jv2Bar) return; w.__jv2Bar = true;
  /* The bar is armed only once the hero's Add to cart has scrolled up past the top of the screen. pdp-atc.js (shared with
     the live pages) shows it whenever that button is merely off screen, which on an iPhone at load includes "just under
     Safari's toolbar", so the bar used to arrive with the hero. CSS draws the bar only when .show AND [data-d-armed]. */
  (function arm() {
    var bar = d.getElementById('stickybuy'), atc = d.getElementById('atc');
    if (!bar) return;
    if (!atc) { bar.setAttribute('data-d-armed', ''); return; }
    /* two observers, no per-frame reads: `seen` = on screen, `upto` = on screen or anywhere above it (the root reaches
       far up). Past = upto && !seen. A flick that carries the button from below the screen to above it in one frame still
       flips `upto`, so it cannot be skipped (one plain observer can be). */
    var seen = false, upto = false;
    function set() { bar.toggleAttribute('data-d-armed', upto && !seen); }
    if (!('IntersectionObserver' in w)) { bar.setAttribute('data-d-armed', ''); return; }
    new IntersectionObserver(function (es) { seen = es[es.length - 1].isIntersecting; set(); }).observe(atc);
    new IntersectionObserver(function (es) { upto = es[es.length - 1].isIntersecting; set(); }, { rootMargin: '1000000px 0px 0px 0px' }).observe(atc);
  })();
  function shown(bar) { return bar.classList.contains('show') && bar.hasAttribute('data-d-armed'); }
  function boot() {
    var S = w.SSD; if (!S || !S.TIERS || !S.tier) return;
    var bar = d.getElementById('stickybuy'), btn = d.getElementById('d-bar-pick'), panel = d.getElementById('d-pick'),
        scrim = d.getElementById('d-pick-scrim'), live = d.getElementById('d-pick-live'), atc = bar && bar.querySelector('[data-sticky-add]');
    if (!bar || !btn || !panel || !scrim) return;
    var T = S.TIERS, order = [1, 2, 5].filter(function (n) { return T[n]; });
    if (order.length < 2) return; /* one size: nothing to choose, the button stays a plain label */
    var isOpen = false, closeT = 0, openY = 0, openW = 0, openH = 0;

    function el(tag, cls, text) { var e = d.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    var head = el('p', 'd-pick-h', panel.getAttribute('data-heading') || ''); head.id = 'd-pick-h';
    var list = el('div', 'd-pick-l'); list.setAttribute('role', 'radiogroup'); list.setAttribute('aria-labelledby', 'd-pick-h');
    order.forEach(function (n) {
      var t = T[n], row = el('label', 'd-pick-r'), inp = d.createElement('input');
      inp.type = 'radio'; inp.name = 'd-pick'; inp.value = n;
      var nm = el('span', 'd-pick-n', t.count); nm.appendChild(el('small', null, t.mlText));
      var sub = el('span', 'd-pick-s'); sub.appendChild(d.createTextNode(t.name));
      if (t.saveIn) { sub.appendChild(d.createTextNode(' · ')); sub.appendChild(el('b', null, t.saveIn)); }
      if (t.eachText) sub.appendChild(d.createTextNode(' · ' + t.eachText));
      row.appendChild(inp); row.appendChild(nm); row.appendChild(sub); row.appendChild(el('span', 'd-pick-p', t.priceText));
      list.appendChild(row);
    });
    var note = el('p', 'd-pick-note'); note.id = 'd-pick-note';
    panel.textContent = ''; panel.appendChild(head); panel.appendChild(list); panel.appendChild(note);
    var radios = panel.querySelectorAll('input[name="d-pick"]');

    /* the picker follows the shared store: the hero tiles and CHOOSE can change it while the panel is shut or open, and a
       tier that sells out mid-session goes dead here at once */
    function sync(n) {
      Array.prototype.forEach.call(radios, function (r) {
        var t = T[+r.value]; r.checked = (+r.value === n); r.disabled = !(t && t.available);
      });
      note.textContent = (T[n] && T[n].note) || '';
    }
    S.tier.on(sync);

    function setOpen(v, focusTo) {
      if (v === isOpen) return; isOpen = v; clearTimeout(closeT);
      panel.classList.toggle('d-open', v); scrim.classList.toggle('d-open', v);
      if (v) panel.removeAttribute('inert'); else panel.setAttribute('inert', '');
      btn.setAttribute('aria-expanded', v ? 'true' : 'false');
      if (v) {
        openY = w.scrollY; openW = w.innerWidth; openH = w.innerHeight; btn.setAttribute('data-d-seen', '');
        if (S.track) S.track('bar_picker_open', { tier: S.tier.get() });
        var cur = panel.querySelector('input:checked'); if (cur) cur.focus({ preventScroll: true });
      } else if (focusTo) focusTo.focus({ preventScroll: true });
      else if (panel.contains(d.activeElement)) {
        /* closed by scroll, resize or the bar hiding: never leave focus inside the now-inert panel */
        var to = shown(bar) ? btn : d.getElementById('atc');
        if (to) to.focus({ preventScroll: true });
      }
    }

    btn.addEventListener('click', function () { setOpen(!isOpen); });
    d.addEventListener('click', function (e) { if (isOpen && !panel.contains(e.target) && !btn.contains(e.target)) setOpen(false); });
    d.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') { e.preventDefault(); setOpen(false, btn); } });
    w.addEventListener('scroll', function () { if (isOpen && Math.abs(w.scrollY - openY) > 90) setOpen(false); }, { passive: true });
    /* a resize that only moves the phone browser's own toolbars is not a reason to shut the panel under a thumb */
    w.addEventListener('resize', function () { if (isOpen && (w.innerWidth !== openW || Math.abs(w.innerHeight - openH) > 120)) setOpen(false); });
    if ('MutationObserver' in w) new MutationObserver(function () { if (isOpen && !shown(bar)) setOpen(false); }).observe(bar, { attributes: true, attributeFilter: ['class', 'data-d-armed'] });

    panel.addEventListener('change', function (e) {
      var n = +e.target.value; if (!T[n]) return;
      if (!S.tier.set(n)) { sync(S.tier.get()); return; } /* sold out: the store refused, put the rows back on the real tier */
      if (S.track) S.track('bar_picker_select', { tier: n });
      if (live) live.textContent = T[n].label + ', ' + T[n].priceText + '.';
    });
    /* a pointer tap on a row closes after a beat (long enough to see the choice land in the bar); arrow keys only browse */
    panel.addEventListener('click', function (e) {
      if (e.target.tagName === 'INPUT' || !e.target.closest('.d-pick-r') || e.detail === 0) return;
      clearTimeout(closeT); closeT = setTimeout(function () { setOpen(false, atc); }, 240);
    });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); setOpen(false, atc); } });
    bar.classList.add('d-pick-on'); /* the chevron and the underline appear only once the panel can really open */
  }
  if (w.SSD && w.SSD.onReady) w.SSD.onReady(boot); else w.addEventListener('load', function () { w.SSD && w.SSD.onReady && w.SSD.onReady(boot); });
})(window, document);
